<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="fas fa-external-link-square-alt mr-4"></i>External CRM System in use</span>
        </h1>
        <main class="overflow-hidden flex-1 place-content-center">
            <div v-if="package" class="flex flex-col text-gray-500 cursor-pointer" @click="edit">
                <template v-if="!editing">
                    <div v-if="package.CRMSystemInUse" class="w-full text-center text-lg/6 hover:text-brand whitespace-pre-wrap" v-text="package.CRMSystemInUse"></div>
                    <div v-else class="w-full text-center text-lg/6 text-gray-300 hover:text-brand font-italic"> No CRM System in use data found</div>
                </template>
                <ui-textarea v-else autoresize name="description" placeholder="Add CRM in use note in here"
                             v-model="editingValue" @blur="finished"></ui-textarea>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        dashboardData: Object,
        dashboardProps: Object,
    },
    data() {
        return {
            package: null,
            editingValue:'',
            editing:false
        }
    },
    computed: {},
    methods: {
        edit(){
            this.editingValue = this.package.CRMSystemInUse
            this.editing = true
        },
        async finished(){
            this.editing = false
            let result = await this.package.updateCRMSystemInUse(this.editingValue)
            this.editingValue = this.package.CRMSystemInUse
        }
    },
    mounted() {
        this.package = this.dashboardData.package
    }
}

</script>